module.exports = __webpack_public_path__ + "img/40_38_069_960.2c602941.jpg";